import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

import { useBankProfile } from '../contexts/BankProfileContext';
import { useAuth } from './useAuth';

interface MessageProps {
	topic: string;
	content: {
		text: string;
	};
	code: string;
	attachments?: File[];
	context?: string;
}

interface SendMessageProps {
	payload: MessageProps;
	signature: string;
}

function useSignMessage() {
	const { session } = useAuth();
	const { selectedProfile } = useBankProfile();

	const handleSendMessage = async ({ payload, signature }: SendMessageProps) => {
		const formData = new FormData();

		formData.append('topic', payload.topic);

		Object.entries(payload.content).forEach(([key, value]) => {
			formData.append(`content[${key}]`, value ?? '');
		});

		formData.append('code', payload.code);

		if (payload.attachments) {
			payload.attachments.forEach((file, index) => {
				formData.append(`attachments[${index}]`, file);
			});
		}

		if (payload.context) {
			formData.append('context', payload.context);
		}

		const response = await axios.post(
			`${import.meta.env.VITE_API_HOST}/api/v1/profiles/${selectedProfile.id}/messages/sign`,
			formData,
			{
				headers: {
					Authorization: session?.tokenized,
					'X-Signature': signature,
				},
			},
		);

		return response.data;
	};

	return useMutation({
		mutationFn: handleSendMessage,
		onSuccess: async (data) => data,
		onError: async (error) => error,
		meta: { suppressGlobalErrors: true },
	});
}

export default useSignMessage;
